import { Tool } from '../types';
import { accountingTools } from './categories/accounting';
import { analyticsTools } from './categories/analytics';
import { automationTools } from './categories/automation';
import { businessIntelligenceTools } from './categories/businessIntelligence';
import { cloudTools } from './categories/cloud';
import { collaborationTools } from './categories/collaboration';
import { communicationTools } from './categories/communication';
import { customerSupportTools } from './categories/customerSupport';
import { designTools } from './categories/design';
import { developmentTools } from './categories/development';
import { documentManagementTools } from './categories/documentManagement';
import { ecommerceTools } from './categories/ecommerce';
import { emailTools } from './categories/email';
import { fieldServiceTools } from './categories/fieldService';
import { formTools } from './categories/forms';
import { freelanceTools } from './categories/freelance';
import { hrTools } from './categories/hr';
import { learningTools } from './categories/learning';
import { legalTools } from './categories/legal';
import { marketingTools } from './categories/marketing';
import { paymentTools } from './categories/payments';
import { phoneTools } from './categories/phone';
import { projectManagementTools } from './categories/projectManagement';
import { propertyManagementTools } from './categories/propertyManagement';
import { salesTools } from './categories/sales';
import { schedulingTools } from './categories/scheduling';
import { securityTools } from './categories/security';
import { serviceManagementTools } from './categories/serviceManagement';
import { socialMediaTools } from './categories/socialMedia';
import { timeTrackingTools } from './categories/timeTracking';
import { videoTools } from './categories/video';
import { websiteBuildingTools } from './categories/websiteBuilding';
import { logger } from './logger';

// Log tool counts before combining
logger.info('Loading tools:', {
  accounting: accountingTools.length,
  analytics: analyticsTools.length,
  automation: automationTools.length,
  businessIntelligence: businessIntelligenceTools.length,
  cloud: cloudTools.length,
  collaboration: collaborationTools.length,
  communication: communicationTools.length,
  customerSupport: customerSupportTools.length,
  design: designTools.length,
  development: developmentTools.length,
  documentManagement: documentManagementTools.length,
  ecommerce: ecommerceTools.length,
  email: emailTools.length,
  fieldService: fieldServiceTools.length,
  forms: formTools.length,
  freelance: freelanceTools.length,
  hr: hrTools.length,
  learning: learningTools.length,
  legal: legalTools.length,
  marketing: marketingTools.length,
  payments: paymentTools.length,
  phone: phoneTools.length,
  projectManagement: projectManagementTools.length,
  propertyManagement: propertyManagementTools.length,
  sales: salesTools.length,
  scheduling: schedulingTools.length,
  security: securityTools.length,
  serviceManagement: serviceManagementTools.length,
  socialMedia: socialMediaTools.length,
  timeTracking: timeTrackingTools.length,
  video: videoTools.length,
  websiteBuilding: websiteBuildingTools.length
});

// Combine all tools into a single array
export const tools: Tool[] = [
  ...accountingTools,
  ...analyticsTools,
  ...automationTools,
  ...businessIntelligenceTools,
  ...cloudTools,
  ...collaborationTools,
  ...communicationTools,
  ...customerSupportTools,
  ...designTools,
  ...developmentTools,
  ...documentManagementTools,
  ...ecommerceTools,
  ...emailTools,
  ...fieldServiceTools,
  ...formTools,
  ...freelanceTools,
  ...hrTools,
  ...learningTools,
  ...legalTools,
  ...marketingTools,
  ...paymentTools,
  ...phoneTools,
  ...projectManagementTools,
  ...propertyManagementTools,
  ...salesTools,
  ...schedulingTools,
  ...securityTools,
  ...serviceManagementTools,
  ...socialMediaTools,
  ...timeTrackingTools,
  ...videoTools,
  ...websiteBuildingTools
];

// Validate tools have required fields
tools.forEach(tool => {
  if (!tool.id || !tool.name || !tool.category) {
    logger.warn('Tool missing required fields:', { tool });
  }
});